import { EventMarketType, EventType } from "app/types/eventType";
import { MarketTypes, SportsNameType } from "app/utils/const";
//
export class MarketsHelper {
  /**
   *
   * @param eventData
   * @returns returns a flat list of all markets in an event
   */
  static getListOfAllMarketsInEvent(eventData: EventType) {
    const allmarkets: EventMarketType[] = [];
    eventData.marketPeriods &&
      eventData.marketPeriods.forEach(mp => {
        mp.marketTypes &&
          mp.marketTypes.forEach(mt => {
            mt.markets && mt.markets.forEach(m => allmarkets.push(m));
          });
      });
    return allmarkets;
  }

  /**
   * Check if event is filtererd by OUTRIGHT market
   */
  static isOutright(
    marketType: string | null,
    sportType: string | null
  ): boolean {
    return (
      marketType === MarketTypes.OUTRIGHT || sportType === SportsNameType.GOLF
    );
  }

  // Check if market type is match odds or match odds three way
  static isMatchOdds(marketType: string | null): boolean {
    return (
      marketType === MarketTypes.MATCH_ODDS ||
      marketType === MarketTypes.MATCH_ODDS_THREE_WAY
    );
  }
}
